import { render, staticRenderFns } from "./Zendesk.vue?vue&type=template&id=5070d0c3&scoped=true&"
import script from "./Zendesk.vue?vue&type=script&lang=js&"
export * from "./Zendesk.vue?vue&type=script&lang=js&"
import style0 from "./Zendesk.vue?vue&type=style&index=0&id=5070d0c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5070d0c3",
  null
  
)

export default component.exports